// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.read-field-container {
	display: flex;
	width: 100%;
}
.read-field-container>input {
	flex: 1 1;
}
.read-field-container .invisible {
	width: 1px;
	padding: 0px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
